import React from 'react';
import Table from '../common/Table';
import { ActivitySpeciesTypeDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface ActivitySpeciesTypeTableProps {
  data: ActivitySpeciesTypeDTO[];
  handleEdit: (row: ActivitySpeciesTypeDTO) => void;
  handleDelete: (row: ActivitySpeciesTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ActivitySpeciesTable: React.FC<ActivitySpeciesTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Category',
          key: 'activityTypeId',
          render: (row: ActivitySpeciesTypeDTO) => (
            <span>{row.activityType?.title || 'Unknown'}</span>
          ),
        },
        {
          label: 'Category',
          key: 'activityCategoryId',
          render: (row: ActivitySpeciesTypeDTO) => (
            <span>{row.activityCategory?.title || 'Unknown'}</span>
          ),
        },

        {
          label: 'Title',
          key: 'title',
        },

        {
          label: 'Display Position',
          key: 'displayPosition',
        },

        {
          label: 'Is Active',
          key: 'isActive',
          render: (row: ActivitySpeciesTypeDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },

        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ActivitySpeciesTable;
